import type {
  ApiNodeDataBusinessData,
  ApiNodeDataCollectData,
  ApiNodeDataIdentityData,
  CollectedDataOption,
} from '@onefootprint/request-types/dashboard';

export const isDataRequired =
  (data: ApiNodeDataCollectData | ApiNodeDataIdentityData | ApiNodeDataBusinessData) => (key: CollectedDataOption) => {
    return data.mustCollectData.includes(key);
  };

export const isDataOptional =
  (data: ApiNodeDataCollectData | ApiNodeDataIdentityData | ApiNodeDataBusinessData) => (key: CollectedDataOption) => {
    if (data.kind === 'business_data') {
      return false;
    }
    return data.optionalData.includes(key);
  };

export const collectsData =
  (data: ApiNodeDataCollectData | ApiNodeDataIdentityData | ApiNodeDataBusinessData) => (key: CollectedDataOption) => {
    return isDataRequired(data)(key) || isDataOptional(data)(key);
  };
